import React, { Component, PropTypes } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { compose, graphql } from 'react-apollo';
import gql from 'graphql-tag';
import _ from 'lodash';
import { Breadcrumb, Button, Icon, Loader } from './../../components';
import breadcrumbLib from './../../lib/breadcrumb-lib';
import graphqlLib from './../../lib/graphql-lib';
import { formatDateForDisplay, formatDateForFilename } from '../../lib/date-format-lib';
import { formatNumberForDisplay } from '../../lib/number-format-lib';
import { setGlobalMsg } from '../../actions/global-msg';

// Import the CSS
import '../../../scss/containers/feeds/_parse-report.scss';

const NHF_SOURCE_URL = 'feeds.newhomefeed.com/zillow/6.Zillow.';
const SECURE_PROTOCOL = 'https://';
const UNSECURE_PROTOCOL = 'http://';

export class ParseReport extends Component {
	state = {
		paths: [{ url: '/feeds', label: 'Feeds' }],
	};

	componentWillMount() {
		if (Number.isNaN(+this.props.params.feedId)) {
			this.props.actions.setGlobalMsg('error', 'Invalid feed id');
		}
	}

	componentWillReceiveProps(nextProps) {
		if (!this.props.feedQuery.error && nextProps.feedQuery.error) {
			this.props.actions.setGlobalMsg('error', 'An internal server error occurred.');
		}
	}

	handleDownloadReport = () => {
		const { feed } = this.props.feedQuery;
		if (!feed || !feed.parseReport) return;

		const lastCompletedDate = formatDateForFilename(feed.lastSucceededAt);
		const feedName = feed.name.replace(/\s+/g, '_');
		const fileName = `${lastCompletedDate}-${feedName}-Parse-Report.json`;
		const fileContent = JSON.stringify(feed.parseReport, null, 2);

		const blob = new Blob([fileContent], { type: 'application/json' });
		const url = window.URL.createObjectURL(blob);
		const link = document.createElement('a');
		link.href = url;
		link.download = fileName;
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
		window.URL.revokeObjectURL(url);
	};

	render() {
		const feedQuery = _.get(this.props, 'feedQuery', {});
		const feed = _.get(feedQuery, 'feed');

		let path = this.state.paths;
		if (feed) {
			path = breadcrumbLib.addFeedToPath(path, feed);
		}

		if (!this.props.feedQuery || feedQuery.error) {
			return null;
		}

		if (feedQuery.loading) {
			return <Loader overlay />;
		}

		return (
			<div className="wrapper">
				<Breadcrumb paths={path} />
				<div className="container feed-parse-report">
					<div className="feed-parse-report-header-container">
						<div className="feed-info-container">
							<h1 className="row feed-info-name">{feed.name}</h1>
							<div className="row">
								<div className="feed-info">
									<div>Feed ID: {feed.rawId}</div>
								</div>
								{feed.lastSucceededAt && (
									<div className="feed-info">
										<div className="row">
											<Icon type="clock" />
											<div>
												Last Completed:{' '}
												{formatDateForDisplay(feed.lastSucceededAt)}
											</div>
										</div>
									</div>
								)}
								{feed.source && (
									<div className="feed-info">
										<div className="row">
											<div>
												Source:{' '}
												{feed.source
													.replace(SECURE_PROTOCOL, '')
													.replace(UNSECURE_PROTOCOL, '')
													.replace(NHF_SOURCE_URL, '')}
											</div>
										</div>
									</div>
								)}
							</div>
						</div>
						<div className="feed-download-button-container">
							<Button
								className="btn btn-blue-border btn-small"
								onClick={this.handleDownloadReport}>
								Download Parse Report
							</Button>
						</div>
					</div>

					<div className="row line"></div>
					<div>
						<div className="row">
							<div className="cell santas-gray">
								<h4>PARSE REPORT</h4>
							</div>
						</div>
						<div className="parse-report-content">
							<div className="parse-report-section">
								<h5 className="santas-gray">Summary</h5>
								<div className="table-container">
									<table className="feeds-list">
										<thead>
											<tr>
												<th className="stat-title">
													Expected Corporations
												</th>
												<th className="stat-title">Found Corporations</th>
												<th className="stat-title">Corporations</th>
												<th className="stat-title">Builders</th>
												<th className="stat-title">Subdivisions</th>
												<th className="stat-title">Plans</th>
												<th className="stat-title">Lots Processed</th>
												<th className="stat-title">Specs Created</th>
												<th className="stat-title">Images</th>
											</tr>
										</thead>
										<tbody>
											<tr>
												<td>
													{feed.parseReport.expectedCorporationNumbers.join(
														', ',
													)}
												</td>
												<td>
													{feed.parseReport.foundCorporationNumbers.join(
														', ',
													)}
												</td>
												<td className="gray-bg">
													Updated / Deleted:{' '}
													<b>
														{formatNumberForDisplay(
															feed.parseReport.corporationsSavedCount,
														)}
													</b>
													<br />
													Total:{' '}
													<b>
														{formatNumberForDisplay(
															feed.parseReport.corporationsCount,
														)}
													</b>
												</td>
												<td className="gray-bg">
													Updated / Deleted:{' '}
													<b>
														{formatNumberForDisplay(
															feed.parseReport.buildersSavedCount,
														)}
													</b>
													<br />
													Total:{' '}
													<b>
														{formatNumberForDisplay(
															feed.parseReport.buildersCount,
														)}
													</b>
												</td>
												<td className="gray-bg">
													Updated / Deleted:{' '}
													<b>
														{formatNumberForDisplay(
															feed.parseReport.subdivisionsSavedCount,
														)}
													</b>
													<br />
													Total:{' '}
													<b>
														{formatNumberForDisplay(
															feed.parseReport.subdivisionsCount,
														)}
													</b>
												</td>
												<td className="gray-bg">
													Updated / Deleted:{' '}
													<b>
														{formatNumberForDisplay(
															feed.parseReport.plansSavedCount,
														)}
													</b>
													<br />
													Total:{' '}
													<b>
														{formatNumberForDisplay(
															feed.parseReport.plansCount,
														)}
													</b>
												</td>
												<td className="gray-bg">
													Created:{' '}
													<b>
														{formatNumberForDisplay(
															feed.parseReport.lotsCreatedCount,
														)}
													</b>
													<br />
													Updated:{' '}
													<b>
														{formatNumberForDisplay(
															feed.parseReport.lotsUpdatedCount,
														)}
													</b>
													<br />
													Total:{' '}
													<b>
														{formatNumberForDisplay(
															feed.parseReport.lotsCount,
														)}
													</b>
												</td>
												<td className="gray-bg">
													<b>
														{formatNumberForDisplay(
															feed.parseReport.specsCreatedCount,
														)}
													</b>
												</td>
												<td className="gray-bg">
													Updated / Deleted:{' '}
													<b>
														{formatNumberForDisplay(
															feed.parseReport.imagesSavedCount,
														)}
													</b>
													<br />
													Total:{' '}
													<b>
														{formatNumberForDisplay(
															feed.parseReport.imagesCount,
														)}
													</b>
												</td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>

							{feed.parseReport.issues && (
								<div className="parse-report-section">
									<h5 className="santas-gray">Issues</h5>
									<div className="issues-content-container">
										<div className="issues-stats-container">
											<table className="feeds-list">
												<thead>
													<tr>
														<th>Issue Code</th>
														<th>Count</th>
													</tr>
												</thead>
												<tbody>
													{Object.entries(
														feed.parseReport.issues.reduce(
															(acc, issue) => {
																acc[issue.code] =
																	(acc[issue.code] || 0) + 1;
																return acc;
															},
															{},
														),
													)
														.sort(([, a], [, b]) => b - a)
														.map(([code, count]) => (
															<tr key={code}>
																<td>{code}</td>
																<td>
																	{formatNumberForDisplay(count)}
																</td>
															</tr>
														))}
													<tr>
														<td>
															<b>Total:</b>
														</td>
														<td>
															{formatNumberForDisplay(
																feed.parseReport.issues.length,
															)}
														</td>
													</tr>
												</tbody>
											</table>
										</div>
										<div className="json-issues-container">
											<pre>
												{JSON.stringify(feed.parseReport.issues, null, 2)}
											</pre>
										</div>
									</div>
								</div>
							)}
						</div>
					</div>
				</div>
			</div>
		);
	}
}

ParseReport.propTypes = {
	feedQuery: PropTypes.object,
	location: PropTypes.object,
	error: PropTypes.object,
	children: PropTypes.node,
	actions: PropTypes.object,
	params: PropTypes.object,
};

const feedQuery = gql`
	query fetchFeed($feedId: EncodedID!) {
		feed(id: $feedId) {
			id
			rawId: id(raw: true)
			name
			lastSucceededAt
			source
			parseReport
		}
	}
`;

export default compose(
	connect(
		state => {
			return {
				user: state.auth.user,
			};
		},
		dispatch => {
			return {
				actions: {
					setGlobalMsg: bindActionCreators(setGlobalMsg, dispatch),
				},
			};
		},
	),
	graphql(feedQuery, {
		name: 'feedQuery',
		skip: props => Number.isNaN(+props.params.feedId),
		options: props => ({
			variables: {
				feedId: graphqlLib.encodeId('feed', props.params.feedId),
			},
		}),
	}),
)(ParseReport);



// WEBPACK FOOTER //
// ./src/assets/js/containers/feeds/ParseReport.js